import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { FlexRow, FlexColumn } from 'styles/Layout';
import { media } from 'styles/Mixins';

export const StyledHeader = styled.h1`
  font-size: 16px;
  font-weight: bold;
  color: ${({ type }) => (type === 'primary' ? '#4F5EA3' : '#5A5A5A')};
  text-align: center;

  ${media.sm`
    font-size: 20px;
    text-align: ${({ align = 'left' }) => align};
    margin-bottom: ${({ marginBottom }) =>
      marginBottom ? `${marginBottom}px` : 0};
    margin-top: ${({ marginTop }) => (marginTop ? `${marginTop}px` : 0)};
  `}
`;

export const Paragraph = styled.p`
  color: #5a5a5a;
  font-size: 14px;
  margin: 0;
  text-align: center;
  margin-bottom: 24px;

  ${media.sm`
    max-width: 385px;
    text-align: left;
    font-size: 18px;
    margin-bottom: ${({ marginBottom }) =>
      marginBottom ? `${marginBottom}px` : 0};
  `}
`;

export const TenantName = styled.p`
  color: #5a5a5a;
  font-size: 18px;
  margin: 0;
  font-weight: bold;
  text-align: center;

  ${media.sm`
    text-align: left;
  `}
`;

export const OwnerIndexContainer = styled.div`
  display: block;
  flex: 1;
`;

export const ReportContainer = styled.div`
  background: #f8f8f8;
  padding: 25px 16px;

  ${media.sm`
    padding: 25px 68px;
  `}
`;

export const ReportContainerInner = styled(FlexRow)`
  padding-bottom: 30px;
  flex-direction: column;
  background: #f8f8f8;

  ${media.sm`
    flex-direction: row;
  `}
`;

export const OwnerReportScore = styled(FlexRow)`
  margin-left: 0px;
  justify-content: center;
  align-items: center;

  ${({ size = 'small' }) =>
    size === 'big' &&
    css`
      flex-direction: column;
      margin-top: 30px;
    `}

  ${({ size = 'small' }) =>
    size === 'small' &&
    media.sm`
    margin-top: 0;
    margin-left: 50px;
  `}

  ${({ size = 'small' }) =>
    size === 'small' &&
    media.md`
    margin-top: 0;
    margin-left: 128px;
  `}
`;

export const OwnerBenefitsContainer = styled(FlexRow)`
  background: white;
  flex-direction: column-reverse;

  ${media.sm`
    flex-direction: row;
    min-height: 410px;
    flex: 1;
  `}
`;

export const OwnerBenefits = styled.div`
  padding: 20px 16px;
  ${media.sm`
    padding: 60px 40px 60px 68px;
  `}
`;

export const OwnerBgContainer = styled.div`
  overflow: hidden;
  text-align: center;
  margin-top: 20px;

  ${media.sm`
    margin-top: 0;
  `}

  img {
    height: 300px;
    ${media.sm`
      height: 410px;
    `}
  }
`;

export const WatchFullReportBtn = styled.button`
  background: none;
  border: none;
  color: #278c7e;
  font-size: 14px;
  font-weight: bold;
  margin: 0 auto;
  display: block;
`;

export const SignUpWrapper = styled.div`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
`;

export const SensitiveDataWarning = styled.h1`
  font-size: 16px;
  color: #5a5a5a;
  text-align: center;
`;

export const SignUpFormContainer = styled(FlexRow)`
  justify-content: center;
  flex-direction: column;
  align-items: center;

  ${media.sm`
    flex-direction: row;
  `}
`;

export const SignUpFormColumn = styled(FlexColumn)`
  width: 300px;
  ${media.sm`
    &:first-child {
      margin-right: 40px;
    }
  `}
`;

export const TaCParagraph = styled.p`
  font-size: 12px;
  color: #5a5a5a;
  margin-bottom: 24px;
  width: 300px;
`;

export const TaCLink = styled(Link)`
  color: #278c7e;
`;

export const ScoreCategoryLabel = styled(Paragraph)`
  text-align: center;
  color: #000;
  margin-bottom: 16px;
`;

export const ScoreComparisonLabel = styled(Paragraph)`
  text-align: center;
  font-size: 14px;
  color: #9b9b9b;
  margin-bottom: 25px;
`;

export const ReportScoreContainer = styled.div`
  margin: 25px 32px 0;
  ${media.sm`
    margin-left: 60px;
    margin-top: 25px;
  `}
`;

export const ReportDetailContainer = styled.div`
  background: white;
  ${media.sm`
    background: transparent;
    margin-top: 25px;
    margin-left: 80px;
    margin-right: 60px;
  `}

  ${media.md`
    background: transparent;  
    margin-top: 25px;
    margin-left: 190px;
    margin-right: 60px;
  `}
`;

export const SummaryContainer = styled.div`
  background: #e7ffdb;
  padding: 32px 32px 25px;

  ${media.sm`
    background: transparent;
    padding: 0;
  `}
`;

export const SummaryField = styled.div`
  margin-bottom: 16px;
`;

export const SummaryFieldLabel = styled.span`
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  margin-right: 12px;
`;

export const SummaryFieldData = styled.span`
  color: #000;
  font-size: 14px;
  font-weight: bold;
`;

export const DetailContainer = styled.div`
  padding: 32px 32px 25px;

  ${media.sm`
    padding: 0;
  `}
`;

export const DetailTitle = styled.p`
  color: black;
  font-size: 16px;
  text-align: left;
  font-weight: bold;

  img {
    margin-right: 8px;
  }
`;

export const DetailField = styled.div`
  margin-bottom: 10px;
`;

export const DetailFieldLabel = styled.div`
  font-size: 10px;
  color: #7c7c7c;
`;

export const DetailFieldData = styled.div`
  color: #5a5a5a;
  font-size: 14px;
`;

export const ValidatedByContainer = styled.div`
  padding: 20px 32px;
`;

export const ValidatedByParagraph = styled.p`
  font-size: 12px;
  color: black;
`;
